// extracted by mini-css-extract-plugin
module.exports = {"form":"classes_form__3tWZ3","container":"classes_container__1r3cB","header":"classes_header__J19JQ","buttons":"classes_buttons__26fpy"};